export default __webpack_public_path__ + "static/media/55_1_4.9352754e.png";